import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { ReservationCompare } from '../models/reservation-compare';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { ResponseUtilService } from '../../shared/utils/response-util.service';
import { AppAuthHttpService } from '../../http/app.auth.http.service';

@Injectable()
export class ReservationCompareService {

  private eventUrl: string = this.environment.baseUrl + '/api/events';

  constructor(private http: AppAuthHttpService,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
  }

  get(eventId: number): Observable<List<ReservationCompare>> {
    const reservationUrl = `${this.eventUrl}/${eventId}/compare`;

    return this.http.get(reservationUrl)
      .map((res: Response) => List<ReservationCompare>(res.json()))
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  getReservations(eventId: number): Observable<List<ReservationCompare>> {
    const reservationUrl = `${this.eventUrl}/${eventId}/reservations/compare`;

    return this.http.get(reservationUrl)
      .map((res: Response) => List<ReservationCompare>(res.json()))
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  getRsvps(eventId: number): Observable<List<ReservationCompare>> {
    const reservationUrl = `${this.eventUrl}/${eventId}/rsvps/compare`;

    return this.http.get(reservationUrl)
      .map((res: Response) => List<ReservationCompare>(res.json()))
      .catch(response => this.responseUtilService.handleError(response)).share();
  }


}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/service/reservation-compare-http-service.ts